import { extendTheme, Theme } from "@chakra-ui/react";
import {
  Menu,
  MenuBadgeCmp,
  ProfileBadgeAvatarCmp,
  ProfileBadgeGreetingCmp,
  ProfileBadgeMenuAvatarCmp,
  ProfileBadgeMenuIconCmp
} from "../profileBadgeStyle";
import { Button } from "./buttons";
import { Checkbox } from "./checkbox";
import { colors } from "./colors";
import { Radio } from "./radioButton";
import { typography } from "./typography";

const Input = {
  baseStyle: {
    field: {
      fontSize: "sm",
      fontFamily: "body",
    },
  },
};

const Textarea = {
  baseStyle: {
    fontSize: "sm",
    fontFamily: "body",
  },
};

const theme: Partial<Theme> = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  components: {
    ProfileBadgeGreetingCmp,
    ProfileBadgeAvatarCmp,
    ProfileBadgeMenuAvatarCmp,
    ProfileBadgeMenuIconCmp,
    Menu,
    MenuBadgeCmp,
    Button,
    Checkbox,
    Radio,
    Input,
    Textarea,
  },
  colors,
  ...typography,
  styles: {
    global: {
      body: {
        fontSize: "md",
      },
    },
  },
  shadows: {
    outline: `0 0 0 3px ${colors.nav.focusRing}`,
    checkbox: `0 0 0 3px ${colors.highlight[200]}`
  }
});

export { theme };
